import { SocialNetworkPostStatus, SocialNetworksId } from "@/interfaces";
import { VideoProject } from "@/services/bedrock";

import { EditorVideoProjectField } from "./components/EditorCaptionSettings";

export function applyEditorField(project: VideoProject, field: EditorVideoProjectField, value: any): VideoProject {
  if (field === "message") {
    const post = project.post ?? {
      id: project.postId ?? -1,
      playerId: project.playerId,
      message: "",
      postDate: "",
      media: [],
      postSocialNetworks: [],
    };
    return { ...project, post: { ...post, message: value } };
  }

  if (field === "socialNetworkIds") {
    if (!project.post) return project;
    const ids = (value ?? []) as SocialNetworksId[];
    const existing = project.post.postSocialNetworks ?? [];
    const postSocialNetworks = ids.map(
      id =>
        existing.find(sn => sn.socialNetworkId === id) ?? {
          id: -1,
          socialNetworkId: id,
          status: SocialNetworkPostStatus.PENDING,
          externalPostUrl: null,
        }
    );
    return { ...project, post: { ...project.post, postSocialNetworks } };
  }

  return { ...project, [field]: value };
}

export function editorProjectUpdateFields(project: VideoProject, hashtags?: string) {
  return {
    message: project.post?.message,
    hashtags,
    isAutoPost: project.isAutoPost,
    preferredPostDate: project.preferredPostDate ?? undefined,
    allowShortLink: project.allowShortLink,
    allowCompliance: project.allowCompliance,
    allowPlayerHashtags: project.allowPlayerHashtags,
    socialNetworkIds: project.post?.postSocialNetworks?.map(sn => sn.socialNetworkId),
  };
}
